/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import Insignias from './Insignias';
import {bindActionCreators} from 'redux'; 
import * as infoActions from '../../actions/infoActions';
import {Auth} from 'aws-amplify';
import toastr from 'toastr';
import ManageList from '../common/ManageList';

import * as menuActions from '../../actions/menuActions'; 
import {usuarioActual} from '../../util';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';

import { Segment} from 'semantic-ui-react'; 
import $ from 'jquery';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';


import {getMargenes} from '../../util/';

class ManageInsigniasInfo extends React.Component  {
    constructor(props, context) {
		
		super(props, context);
        this.state={
            insignias:[]
		};
	}

	componentDidMount(){
      usuarioActual(this, "insignia",false);
		window.scrollTo(0, 0);
        this.props.infoActions.getInsigniaInfo().then( insignias=>{
           this.setState({"insignias":insignias});
       })
        .catch(error=>{
          toastr.error(error);
        }); 
        
       
    this.props.showSidebarIzquierdaActions.sidebarIzquierda(false);
        
	}
        
  
    
    render() {
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 
		return (
            <Segment style={margenes}>
                  
                <Insignias
                    strings={this.props.strings}
                    insignias={this.state.insignias}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                  
  
                />
            
          

            </Segment> 
            
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps){
    return {
        
         showSidebarIzquierda: state.showSidebarIzquierda,
         sidebarIzquierda: state.sidebarIzquierda,
         ajaxCallInProgress:state.ajaxCallInProgress,
         color:state.color,
         form:state.form,
        strings:state.strings,
        idioma:state.idioma,
        user:state.user
    }

}

function mapDispatchToProps(dispatch){

	return {  
        menuActions: bindActionCreators(menuActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
            infoActions: bindActionCreators(infoActions, dispatch),
			
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageInsigniasInfo);